
import {defineComponent} from "vue";
import {FormMixin} from "@/components/base/FormMixin";
import AlertError2 from "@/components/UI/Bootstrap/Alert/AlertError2.vue";
import BaseTitle from "@/components/UI/BaseTitle.vue";
import ContentPreviewOverviewItem from "@/components/layouts/previews/ContentPreviewOverviewItem.vue";
import {ContentPreviewRestService} from "@/services/rest/cms-content-preview/ContentPreviewRestService";
import {ContentPreviewOverviewRestDto} from "@/api/pharma-cms-content-preview/models";
import {arrayHasContent} from "@/helpers/functions/arrays";
import {AuthContext} from "@/context/AuthContext";

export default defineComponent({
  name: "ContentPreviewOverview",
  mixins: [FormMixin],
  components: {AlertError2, BaseTitle, ContentPreviewOverviewItem},
  data: () => ({
    contentPreviews: [] as ContentPreviewOverviewRestDto[],
  }),
  mounted() {
    this.reloadContent();
  },
  computed: {
    hasContentPreviews(): boolean {
      return arrayHasContent(this.contentPreviews);
    },
  },
  methods: {
    async doReload(): Promise<void> {
      this.contentPreviews = await ContentPreviewRestService.getInstance().findContentPreviewOverview();
    },
    hasAuthorization(): boolean {
      return AuthContext.isDpUser();
    },
  },
});
